import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=ec297d32&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=ec297d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec297d32",
  null
  
)

export default component.exports